import { Form, Formik } from 'formik'
import { MdDone } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { useFormatCurrency } from '../../../lib/CurrencyFormatter'
import { isCurrency } from '../../../lib/Validations'
import Button from '../../Formik/Button'
import Input from '../../Formik/Input'

interface Props {
  amount: number
  isActive: boolean
  activate: () => void
  save: (amount: number) => void
  editable?: boolean
}

const SpendColumn = ({
  amount,
  isActive,
  activate,
  save,
  editable = true,
}: Props) => {
  const { t } = useTranslation(['budget', 'common'])
  const formatCurrency = useFormatCurrency()

  return (
    <>
      {isActive && editable && (
        <Formik
          initialValues={{
            amount,
          }}
          validationSchema={Yup.object({
            amount: Yup.string()
              .transform((currentValue) => {
                // First remove all danish thousand seperators (.) and then replace the danish delimiter seperator (,) with the english one (.).
                // This way it's possible to save floats.
                return currentValue.replaceAll('.', '').replaceAll(',', '.')
              })
              .required(t('common:validation.required'))
              .test(isCurrency),
          })}
          onSubmit={({ amount }) => save(amount)}
        >
          <div className='grow'>
            <Form>
              <div className='flex'>
                <Input
                  type='number'
                  name='amount'
                  placeholder={t('budget:shared.amountPlaceholder')}
                  size='sm'
                  className='flex-1 sm:w-20 appearance-none'
                />
                <Button size='sm' type='submit' className='ml-1'>
                  <MdDone />
                </Button>
              </div>
            </Form>
          </div>
        </Formik>
      )}
      {(!isActive || !editable) && (
        <div
          className={editable ? 'grow cursor-text' : 'grow'}
          onClick={editable ? activate : undefined}
        >
          {formatCurrency(amount as number, true, false)}
        </div>
      )}
    </>
  )
}

export default SpendColumn
